import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getAuthService } from '@edx/frontend-platform/auth';

const additionalDetailsApiUrl = () => `${getConfig().LMS_BASE_URL}/blendxapi/learner/additional-details/`;

/**
 * Drop any CSRF token cached by frontend-platform.
 *
 * The MFE caches a CSRF token (in memory, per-domain) the first time it issues an
 * unsafe request. On this screen that token was fetched while the user was still
 * anonymous on the login page, but Django rotates the CSRF token at login — so the
 * cached value is stale and POSTs fail with a 403 ("CSRF token from the
 * 'X-Csrftoken' HTTP header incorrect."). Clearing the cache forces the interceptor
 * to fetch a fresh token bound to the now-authenticated session before the request.
 */
function clearStaleCsrfToken() {
  const csrfTokenService = getAuthService()?.getCsrfTokenService?.();
  if (csrfTokenService?.clearCsrfTokenCache) {
    csrfTokenService.clearCsrfTokenCache();
  }
}

/**
 * Fetch the org's additional-detail field definitions together with the
 * authenticated learner's saved answers.
 * @returns {Promise<{schema: Array, values: Object}>}
 */
export async function getAdditionalDetails() {
  const { data } = await getAuthenticatedHttpClient().get(additionalDetailsApiUrl());
  return { schema: data?.schema || [], values: data?.values || {} };
}

/**
 * Save the authenticated learner's additional details.
 * @param {Object} values Field name -> value. Partial saves are supported.
 */
export async function saveAdditionalDetails(values) {
  clearStaleCsrfToken();
  const { data } = await getAuthenticatedHttpClient().post(additionalDetailsApiUrl(), values);
  return data;
}
